__turbopack_context__.v({
  "logo": "spinner-module-scss-module__--vZkW__logo",
  "mask": "spinner-module-scss-module__--vZkW__mask",
});
